<template>
  <div
    v-if="selected_event_type == 'Past Events'"
    class="bg-white lg:pt-12 md:pt-12 pt-8 lg:mt-0 md:mt-0 mt-4 lg:px-20 md:px-10 px-5"
  >
    <div v-if="album.hasOwnProperty('images') && album.images.length != 0">
      <div class="lg:flex md:flex justify-center gap-6 mb-6 mt-3">
        <div class="lg:w-2/5 md:w-1/2">
          <img
            v-if="album.images[currentIndex] != ''"
            :src="`${$imageURL}/` + album.images[currentIndex]"
            alt="img"
            class="w-full lg:h-80 md:h-72 h-64 rounded-lg object-cover"
          />
          <img
            v-else
            src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
            alt="img"
            class="w-full lg:h-80 md:h-72 h-64 rounded-lg object-cover"
          />
        </div>
      </div>

      <div class="mt-2">
        <p
          class="fsize18 md-fsize18 sm-fsize14 font-normal lh40px sm-lh20 text-center"
        >
          {{ album.albumDescription }}
        </p>
      </div>

      <div>
        <swiper class="swiper lg:mt-10 md:mt-10 mt-8" :options="swiperOptions">
          <!-- <swiper-slide>
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
            alt="img"
            class="w-full h-36 rounded-lg cursor-pointer"
          />
        </swiper-slide>
        <swiper-slide>
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
            alt="img"
            class="w-full h-36 rounded-lg cursor-pointer"
          />
        </swiper-slide>
        <swiper-slide>
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
            alt="img"
            class="w-full h-36 rounded-lg cursor-pointer"
          />
        </swiper-slide>
        <swiper-slide>
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
            alt="img"
            class="w-full h-36 rounded-lg cursor-pointer"
          />
        </swiper-slide>
        <swiper-slide>
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
            alt="img"
            class="w-full h-36 rounded-lg cursor-pointer"
          />
        </swiper-slide> -->
          <swiper-slide v-for="(item, i) in album.images" :key="i">
            <img
              v-if="item != ''"
              :src="`${$imageURL}/` + item"
              alt="img"
              class="w-full h-36 rounded-lg cursor-pointer"
              @click="changeIndex(i)"
            />
            <img
              v-else
              src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
              alt="img"
              class="w-full h-36 rounded-lg cursor-pointer"
              @click="changeIndex(i)"
            />
          </swiper-slide>
          <div class="swiper-button-prev gallery" slot="button-prev"></div>
          <div class="swiper-button-next gallery" slot="button-next"></div>
        </swiper>
      </div>
    </div>
    <div v-else>No Album</div>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 5,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1600: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
          1300: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
          1240: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
          900: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
          856: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
        },
        // autoplay: {
        //   delay: 4000,
        //   disableOnInteraction: false,
        // },
      },

      currentIndex: 0,
      album: {},
    };
  },
  computed: {
    ...mapState("mainAboutUs", { banner: "banner" }),
    ...mapState("ffc", ["selected_event", "selected_event_type"]),
  },
  methods: {
    changeIndex(index) {
      this.currentIndex = index;
    },
    async getAlbumData() {
      let payload = {
        eventName: this.selected_event._id,
      };
      const { data } = await this.$store.dispatch(
        "gallery/getAlbumById",
        payload
      );
      console.log(data.album, "getAlbum");
      this.album = data.album;
    },
  },
  async mounted() {
    this.getAlbumData();
  },
};
</script>
<style>
.gallery.swiper-button-next,
.swiper-button-prev {
  height: 43px !important;
  top: 55% !important;
}
</style>
